export function fetchClassItem(item) {
  if (!item.is_viewed) {
    return 'blue lighten-5';
  }
  return '';
}

export function checkIndicatorOrder(item, action) {
  let additional = item?.additional?.value
  let result = false
  switch (action) {
    case 'bread':
      if (additional?.additional_bread) {
        result = true
      }
      break;
    case 'vegetables':
      if (additional?.additional_vegetables) {
        result = true
      }
      break;
    case 'meat':
      if (item?.details) {
        result = true
      }
      break;
  }
  return result;
}